import script from "./NewDashboardView.vue?vue&type=script&setup=true&lang=js"
export * from "./NewDashboardView.vue?vue&type=script&setup=true&lang=js"

import "./NewDashboardView.vue?vue&type=style&index=0&id=04bade76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04bade76"]])

export default __exports__